export interface StackerBundle {
	StackerBundleId: number;
	ShiftId: number;
	SectionId: number;
	SectionName: string;
	GradeId: number | null;
	GradeName: string | null;
	HeatId: number | null;
	HeatName: string | null;
	LengthInches: number;
	GoodBundles: number;
	GoodPiecesPerBundle: number;
	TotalPieces: number;
	TotalWeight: number | null;
	ScrapBundles: number | null;
	ScrapPiecesPerBundle: number | null;
	ScrapReason: string | null;
	GoodPieces?: number;
	ScrapPieces?: number | null;
	SortOrder: number;
	CreatedAt: Date | null;
	CreatedBy: number | null;
	CreatedByName: string | null;
	ModifiedAt: Date | null;
	ModifiedBy: number | null;
	ModifiedByName: string | null;
}

export const STACKER_BUNDLE_DRAFT_INITIAL: StackerBundleDraft = {
	StackerBundleId: null,
	ShiftId: 0,
	SectionId: 0,
	GradeId: null,
	HeatId: null,
	LengthInches: 0,
	GoodBundles: 0,
	GoodPiecesPerBundle: 0,
	TotalPieces: null,
	TotalPiecesIsManual: false,
	TotalWeight: null,
	ScrapBundles: null,
	ScrapPiecesPerBundle: null,
	ScrapReason: null,
};

// M1 (pieces-only) initial draft. Bundle fields stay zeroed/null and are ignored.
export const STACKER_PIECES_DRAFT_INITIAL: StackerBundleDraft = {
	...STACKER_BUNDLE_DRAFT_INITIAL,
	GoodPieces: 0,
	ScrapPieces: null,
};

export type StackerBundleDraft = Omit<
	StackerBundle,
	| "StackerBundleId"
	| "SectionName"
	| "GradeName"
	| "HeatName"
	| "TotalPieces"
	| "CreatedAt"
	| "CreatedBy"
	| "CreatedByName"
	| "ModifiedAt"
	| "ModifiedBy"
	| "ModifiedByName"
	| "SortOrder"
> & {
	StackerBundleId: number | null;
	TotalPieces?: number | null;
	TotalPiecesIsManual: boolean;
};

export interface StackerHeat {
	CurrentHeatName: string | null;
	CurrentGradeName: string | null;
	PreviousHeatName: string | null;
	PreviousGradeName: string | null;
}
